import { Component, Input, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterLink } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { NgForOf, NgIf, NgTemplateOutlet } from "@angular/common";
import { Organization } from "../../../common/models/organization";
import { User } from "../../../common/models/user";
import { MatIconModule } from "@angular/material/icon";
import { Observable, of, tap } from "rxjs";
import { AppDatePipe } from "../../../common/pipes/app-date";
import { TestProvider, TestShortResume } from "../../../test/providers/test-provider";
import { ErrorManagerService } from "../../../common/providers/error-manager-service";
import { LangsProvider } from "../../../common/providers/langs-provider";

@Component({
    selector: 'athlete-last-test-box',
    templateUrl: './last-test-box.html',
    styleUrls: ['./last-test-box.scss'],
    standalone: true,
  imports: [
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    RouterLink,
    TranslateModule,
    MatProgressSpinnerModule,
    NgIf,
    AppDatePipe,
    NgTemplateOutlet,
    NgForOf,
  ],
})
export class LastTestBoxComponent implements OnInit {
  @Input()
  public organization: Organization | null = null;
  @Input()
  public athleteUser: User = {} as User;

  public isLoading: boolean = true;
  public hasFatalError: boolean = false;
  public currentLang: string;

  public lastTest: TestShortResume = {} as TestShortResume;

  constructor(
    private ts: TranslateService,
    private langsProvider: LangsProvider,
    private testsProvider: TestProvider,
    private errorManagerService: ErrorManagerService,
  ) {
    this.currentLang = ts.currentLang;
  }

  public ngOnInit() {
    this.fetchAthleteLastTest().subscribe({
      next: (lastTest) => {
        this.lastTest = lastTest;
      },
      error: (error) => {
        console.error('Error fetching athlete last test', error);
      }
    });
  }


  private fetchAthleteLastTest() : Observable<TestShortResume> {
    this.isLoading = true;
    if (!this.organization?.code || !this.athleteUser.id) {
      this.errorManagerService.error('Error while loading last test');
      this.hasFatalError = true;
      this.isLoading = false;
      return of({} as TestShortResume);
    }
    return this.testsProvider.findLatestTest({
      organization: this.organization,
      athleteUser: this.athleteUser,
      langId: this.langsProvider.getBestLangId(),
    }).pipe(
      tap(() => this.isLoading = false),
    );
  }
}
